import { render } from "./Transaction.vue?vue&type=template&id=ecb4dcfa&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=ecb4dcfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb4dcfa"]])

export default __exports__